import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

import { ArrowDir } from '../utils';
import { BG, MAIN_BODY_WIDTH, RADIUS, TAIL_WIDTH } from './constants';

type ArrowBodyProps = {
  side?: ArrowDir;
  bgColor?: string;
  tailColor: BoxProps['bg'];
  children?: React.ReactNode;
  isLast?: boolean;
} & BoxProps;

const ArrowBody = ({
  side,
  bgColor = BG,
  tailColor,
  children,
  isLast,
  ...props
}: ArrowBodyProps) => {
  const isRight = side === 'right';

  return (
    <Box position="relative" w="100%" zIndex={3} overflow="visible" {...props}>
      {/* Main section */}
      <Box
        position="absolute"
        top={0}
        w={MAIN_BODY_WIDTH[side ?? 'left']}
        h="100%"
        bg={bgColor}
        {...(isRight
          ? { left: 0, borderBottomLeftRadius: RADIUS }
          : { right: 0, borderBottomRightRadius: RADIUS })}
      />
      {/* Tail section (matches next arrow) */}
      <Box
        display={{ base: 'block', md: isLast ? 'none' : 'block' }}
        position="absolute"
        top={0}
        w={`calc(${TAIL_WIDTH[side ?? 'left']} + 1px)`}
        h="100%"
        bg={tailColor}
        {...(isRight
          ? {
              right: 0,
              borderTopRightRadius: RADIUS,
              borderBottomRightRadius: { base: isLast ? RADIUS.base : '7px', md: 0 },
            }
          : {
              left: 0,
              borderTopLeftRadius: RADIUS,
              borderBottomRightRadius: { base: isLast ? RADIUS.base : 0, md: 0 },
              borderBottomLeftRadius: { base: '7px', md: 0 },
            })}
      />

      {/* Content */}
      <Box position="relative" zIndex={1} h="100%">
        {children}
      </Box>
    </Box>
  );
};

export default ArrowBody;
